function bindAccessoryGalleries(root=document){
 root.querySelectorAll('[data-lxa-gallery]').forEach(gallery=>{
  if(gallery.dataset.bound)return;
  gallery.dataset.bound='true';
  const track=gallery.querySelector('[data-lxa-track]');
  const photos=[...gallery.querySelectorAll('[data-lxa-photo]')],buttons=[...gallery.querySelectorAll('[data-lxa-thumb]')];
  const directions=[...gallery.querySelectorAll('[data-lxa-direction]')],counter=gallery.querySelector('[data-lxa-counter]');
  const thumbs=gallery.querySelector('.lxa-thumbnails'),positionLabel=gallery.querySelector('[data-lxa-position-label]');
  let current=0,frame=0,selection=0;
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const paint=index=>{
   current=index;
   buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
   counter.textContent=(index+1)+' / '+photos.length;
   if(positionLabel)positionLabel.textContent=photos[index].dataset.lxaPosition||'';
   directions.forEach(button=>button.disabled=Number(button.dataset.lxaDirection)<0?index===0:index===photos.length-1);
   const button=buttons[index],left=button.offsetLeft-thumbs.offsetLeft;
   if(left<thumbs.scrollLeft)thumbs.scrollTo({left,behavior:'auto'});
   else if(left+button.offsetWidth>thumbs.scrollLeft+thumbs.clientWidth)thumbs.scrollTo({left:left+button.offsetWidth-thumbs.clientWidth,behavior:'auto'});
  };
  const select=async index=>{
   index=Math.max(0,Math.min(photos.length-1,index));
   const request=++selection,image=photos[index].querySelector('img');
   image?.setAttribute('loading','eager');
   try{await image?.decode();}catch{}
   if(request!==selection)return;
   const sameFrame=photos[current].dataset.lxaPosition&&photos[index].dataset.lxaPosition;
   paint(index);
   track.scrollTo({left:index*track.clientWidth,behavior:sameFrame||reduced()?'instant':'smooth'});
  };
  const keyIndex=(key,index)=>key==='Home'?0:key==='End'?photos.length-1:index+(key==='ArrowRight'?1:-1);
  buttons.forEach((button,i)=>{
   button.addEventListener('click',()=>select(i));
   button.addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();
    const next=Math.max(0,Math.min(photos.length-1,keyIndex(event.key,i)));
    select(next);buttons[next].focus({preventScroll:true});
   });
  });
  directions.forEach(button=>button.addEventListener('click',()=>select(current+Number(button.dataset.lxaDirection))));
  track.addEventListener('keydown',event=>{
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();select(keyIndex(event.key,current));
  });
  track.addEventListener('scroll',()=>{
   if(frame)return;
   frame=requestAnimationFrame(()=>{frame=0;const index=Math.round(track.scrollLeft/track.clientWidth);if(index!==current)paint(index);});
  },{passive:true});
  const resize=new ResizeObserver(()=>track.scrollTo({left:current*track.clientWidth,behavior:'instant'}));
  resize.observe(track);
  gallery.addEventListener('shopify:section:unload',()=>resize.disconnect(),{once:true});
  paint(0);
 });
}
bindAccessoryGalleries();
document.addEventListener('shopify:section:load',event=>bindAccessoryGalleries(event.target));
function bindAccessorySelection(root=document){
 root.querySelectorAll('.lxa-pdp').forEach(pdp=>{
  if(pdp.dataset.selectionBound)return;
  const cards=[...pdp.querySelectorAll('[data-lxa-select]')];
  const records=new Map([...pdp.querySelectorAll('template[data-lxa-record]')].map(t=>[t.dataset.lxaRecord,t]));
  const form=pdp.querySelector('form[is="product-form"]');
  const variantInput=form?.querySelector('input[name="id"]');
  if(!cards.length||!variantInput||cards.some(c=>!records.has(c.dataset.lxaSelect)))return;
  pdp.dataset.selectionBound='true';
  const setSelection=handle=>{
   const record=records.get(handle);
   if(!record)return;
   const data=record.dataset;
   pdp.dataset.price=data.price;
   pdp.dataset.selectedVariantId=data.variantId;
   variantInput.value=data.variantId;
   variantInput.disabled=false;
   const productInput=form.querySelector('input[name="product-id"]');
   if(productInput)productInput.value=data.productId;
   pdp.querySelector('.product-info__title').textContent=data.title;
   pdp.querySelector('.lxa-breadcrumb>span:last-child').textContent=data.title;
   pdp.querySelectorAll('[data-lxa-size]').forEach(e=>e.textContent=data.size);
   pdp.querySelectorAll('[data-lxa-studio-image]').forEach(image=>image.alt=image.dataset.lxaImageDescription?image.dataset.lxaImageDescription+' · '+data.title:data.title);
   pdp.querySelector('.product-info__price').replaceChildren(record.content.querySelector('[data-lxa-price]').cloneNode(true));
   const submit=form.querySelector('[type="submit"]');
   submit.disabled=data.available!=='true';
   const label=submit.querySelector(':scope > div')||submit;
   label.textContent=data.button;
   const quantity=pdp.querySelector('.product-info__quantity-selector');
   if(quantity)quantity.hidden=data.available!=='true';
   cards.forEach(card=>{
    const active=card.dataset.lxaSelect===handle;
    card.setAttribute('aria-pressed',String(active));
    if(active)card.setAttribute('aria-current','page');else card.removeAttribute('aria-current');
   });
   pdp.querySelector('[data-lxa-selection-status]').textContent=data.title+' · '+record.content.querySelector('sale-price').textContent.trim();
   const url=new URL(location.href);
   url.pathname=data.url;
   url.searchParams.delete('variant');
   history.replaceState(history.state,'',url);
   document.title=data.title+' | LuxSol';
   syncAccessoryStock(pdp);
   variantInput.dispatchEvent(new Event('change',{bubbles:true}));
  };
  cards.forEach(card=>{
   card.setAttribute('role','button');
   card.setAttribute('aria-pressed',String(card.hasAttribute('aria-current')));
   card.addEventListener('click',event=>{
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
    event.preventDefault();
    if(form.querySelector('[aria-busy="true"]'))return;
    setSelection(card.dataset.lxaSelect);
   });
   card.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();card.click();}});
  });
 });
}
bindAccessorySelection();
document.addEventListener('shopify:section:load',event=>bindAccessorySelection(event.target));

// Keep the stock app's own presentation, payment controls and purchase guards.
// Only extend its records to the preloaded sibling products.
function syncAccessoryStock(pdp){
 const widget=pdp.querySelector('luxsol-stock-arrival');
 if(!widget?.renderPromise)return;
 const form=pdp.querySelector('form[is="product-form"]');
 const source=pdp.querySelector('[data-luxsol-variant-promises]');
 if(!source||!form)return;
 const original=JSON.parse(source.textContent||'{}');
 const defaults=Object.values(original)[0];
 if(!defaults)return;
 const promises={...original};
 pdp.querySelectorAll('template[data-lxa-record]').forEach(record=>{
  const data=record.content.querySelector('[data-lxa-stock-data]')?.dataset;
  if(!data)return;
  const promise=JSON.parse(data.promise||'null');
  promises[record.dataset.variantId]={...defaults,
   managed:!!promise, state:promise?.state||(record.dataset.available==='true'?'IN_STOCK':'SOLD_OUT'),
   shopifyAvailable:record.dataset.available==='true', schedule:promise?.schedule||[],
   depositPlanId:data.depositPlanId||null, fullPrice:data.fullPrice, depositPrice:data.depositPrice
  };
 });
 widget.promises=promises;
 widget.registerDepositPlans();
 widget.renderPromise(pdp.dataset.selectedVariantId||form.querySelector('input[name="id"]').value);
 paintAccessoryStock(pdp,widget);
}
function bindAccessoryStock(root=document){
 root.querySelectorAll('.lxa-pdp').forEach(pdp=>{
  if(pdp.dataset.stockBound||!pdp.querySelector('luxsol-stock-arrival'))return;
  pdp.dataset.stockBound='true';
  const form=pdp.querySelector('form[is="product-form"]');
  const quantity=pdp.querySelector('.product-info__quantity-selector input');
  if(quantity&&form&&!form.contains(quantity)){
   // The native quantity control sits outside the form. Give the stock app and
   // cart one shared form-owned value, rather than submitting duplicate fields.
   const proxy=document.createElement('input');
   proxy.type='hidden';proxy.name='quantity';proxy.value=quantity.value;
   quantity.removeAttribute('name');form.appendChild(proxy);
   const update=()=>{
    proxy.value=String(Math.max(1,parseInt(quantity.value,10)||1));
    syncAccessoryStock(pdp);
   };
   quantity.addEventListener('input',update);
   quantity.addEventListener('change',update);
   quantity.closest('quantity-selector')?.addEventListener('click',()=>queueMicrotask(update));
   quantity.addEventListener('keydown',event=>{
    if(['ArrowUp','ArrowDown'].includes(event.key))queueMicrotask(update);
   });
   form.addEventListener('submit',update,{capture:true});
  }
  customElements.whenDefined('luxsol-stock-arrival').then(()=>syncAccessoryStock(pdp));
 });
}
bindAccessoryStock();
document.addEventListener('shopify:section:load',event=>bindAccessoryStock(event.target));

function paintAccessoryStock(pdp,widget){
 const template=pdp.querySelector('template[data-lxa-stock-layout]');
 if(!template)return;
 if(!widget.dataset.lxaStyled){
  widget.dataset.lxaStyled='true';
  const label=widget.querySelector('.luxsol-stock-arrival__label');
  const message=widget.querySelector('.luxsol-stock-arrival__message');
  const payments=widget.querySelector('[data-luxsol-payment-fieldset]');
  const layout=template.content.cloneNode(true);
  layout.querySelector('[data-lxa-stock-state]').append(label);
  if(message){message.hidden=true;message.removeAttribute('aria-live');}
  widget.replaceChildren(layout);
  if(message)widget.append(message);
  if(payments)widget.append(payments);
 }
 const labels=pdp.querySelector('[data-lxa-stock-labels]').dataset;
 const stock=widget.promises?.[widget.dataset.variantId];
 const quantity=Math.max(1,parseInt(pdp.querySelector('.product-info__quantity-selector input')?.value,10)||1);
 const state=widget.dataset.stockState;
 let capacity=0,arrival=null;
 for(const tranche of stock?.schedule||[]){
  capacity+=Math.max(0,Number(tranche.capacity)||0);
  if(quantity<=capacity){arrival=tranche.date||null;break;}
 }
 const text=(selector,value)=>{widget.querySelector(selector).textContent=value;};
 const preorder=state==='PREORDER',soldOut=state==='SOLD_OUT';
 text('[data-lxa-stock-title]',preorder&&arrival?new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(arrival+'T12:00:00Z')):soldOut?labels.soldOutTitle:preorder?stock.labels.preorder:labels.inStockTitle);
 text('[data-lxa-stock-context]',soldOut?labels.soldOutContext:preorder?labels.preorderContext:labels.inStockContext);
 text('[data-lxa-stock-next]',soldOut?labels.soldOutNext:preorder?labels.preorderNext:labels.inStockNext);
 const size=pdp.querySelector('[data-lxa-size]')?.textContent||pdp.querySelector('.lxa-selected-finish strong')?.textContent||'';
 text('[data-lxa-stock-selection]',size);
 text('[data-lxa-stock-selected-quantity]',labels.quantity+' '+quantity);
 widget.querySelector('[data-lxa-stock-quantity]').hidden=soldOut||!stock?.schedule?.length;
 widget.querySelector('[data-lxa-stock-only]').hidden=capacity>5;
 text('[data-lxa-stock-count]',String(capacity));
 text('[data-lxa-stock-count-copy]',preorder?labels.incoming:labels.remaining);
 const total=pdp.querySelector('[data-lxa-total]');
 if(total)total.textContent=new Intl.NumberFormat('en-GB',{style:'currency',currency:pdp.dataset.currency||'GBP'}).format((Number(pdp.dataset.price)||0)*quantity/100);
}
